import { createTheme } from "@mui/material/styles";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    invert: true;
  }
}

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 628,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: [
      "Open Sans Variable",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h5: {
      fontSize: 22,
      fontWeight: 700,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: 16,
      fontWeight: 600,
      textTransform: "none",
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
    },
  },
  palette: {
    error: {
      light: "#ff5c7a",
      main: "#DC173E",
      dark: "#b0122f",
      contrastText: "#fff",
    },
    primary: {
      light: "rgba(0, 82, 165, 0.04)",
      main: "#0052a5",
      dark: "#003d7a",
      contrastText: "#fff",
    },
    success: {
      light: "#33b733",
      main: "#00A507",
      dark: "#008405",
      contrastText: "#fff",
    },
    secondary: {
      light: "#f5faff",
      main: "#f0f5fa",
      dark: "#D8E6F3",
      contrastText: "#0052a5",
    },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        standardError: {
          background: "#FEF2F2",
          color: "#B91C1C",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
      variants: [
        {
          props: { variant: "invert", color: "error" },
          style: {
            color: "#DC173E",
            backgroundColor: "#fff",

            "&:hover": {
              backgroundColor: "#fff",
            },
          },
        },
      ],
    },
  },
  shape: {
    borderRadius: 10,
  },
});
